const GroupScopeType = {
  COURSE: 'course',
  SESSION: 'session',
  S12N: 'specialization',
  GENERAL: 'general',
  PROGRAM: 'program',
};

export default GroupScopeType;

export const { COURSE, SESSION, S12N, GENERAL, PROGRAM } = GroupScopeType;
